import React, { useState, useEffect } from 'react';
import Logo from "../images/logo.svg";
import { ReactComponent as PasswordShow } from "../images/icon-eye.svg";
import { ReactComponent as PasswordHide } from "../images/icon-eye-hide.svg";
import { ReactComponent as IconValid } from "../images/IconValid.svg"; // Your custom check icon
import { ReactComponent as IconInvalid } from "../images/IconInvalid.svg"; // Your custom cross icon
import PasswordChecklist from "react-password-checklist";
import IconInfo from "../images/IconErrorInfo.svg";
import IconError from "../images/IconError.svg";
import IconCheckError from "../images/IconCheckError.svg"
import { useNavigate } from "react-router-dom";
import Sidebar from '../component/Sidebar';
import { ChakraProvider, useToast, Wrap } from '@chakra-ui/react'
import { encryptData, decryptData } from "./cryptoUtil";

const ChangePassword = () => {

  const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
  const [tabName, setTabName] = useState('Change Password');
  const userid = sessionStorage.getItem("userId");
  const emailId = sessionStorage.getItem("email");

  useEffect(() => {
    document.title = tabName;
  }, [tabName]);

  const toast = useToast();
  const toastIdRef = React.useRef();

  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [passwordAgain, setPasswordAgain] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [isPasswordFilled, setIsPasswordFilled] = useState(false);
  const [validity, setValidity] = useState({
    minLength: false,
    capital: false,
    specialChar: false,
  });

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const togglePasswordVisibility2 = () => {
    setShowPassword2(!showPassword2);
  };

  const togglePasswordVisibility1 = () => {
    setShowPassword1(!showPassword1);
  };

  
  const handleOldPasswordChange = (e) => {
    setOldPassword(e.target.value);
  };


  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    setIsPasswordFilled(newPassword.length > 0);

    // Example validation criteria (adjust as per your requirements)
    const isMinLengthValid = newPassword.length >= 8;
    const hasCapitalLetter = /[A-Z]/.test(newPassword);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(newPassword);

    setValidity({
      minLength: isMinLengthValid,
      capital: hasCapitalLetter,
      specialChar: hasSpecialChar,
      // Update other validity checks here
    });
  };

  const handlePasswordAgainChange = (e) => {
    setPasswordAgain(e.target.value);
    setIsPasswordFilled(!!e.target.value); // Update isPasswordFilled based on input
  };

  const updateValidity = (value) => {
    const minLengthValid = value.length >= 8;
    const capitalValid = /[A-Z]/.test(value);
    const specialCharValid = /[!@#$%^&*(),.?":{}|<>]/.test(value);

   
  };



  const handleChangePassword = async () => {
   
    if (!oldPassword) {
      toastIdRef.current = toast({ description: "Old Password is required.", status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
      return false;
    }

    if (!password) {
      toastIdRef.current = toast({ description: "New Password is required.", status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
      return false;
    }
    if (!passwordAgain) {
      toastIdRef.current = toast({ description: "Confirm Password is required.", status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
      return false;
    }

    if (password && passwordAgain && password !== passwordAgain) {
      toastIdRef.current = toast({ description: "New Password and Confirm Password do not match.", status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
      return false;
    }
   
    // Perform action on change password click
    if (isPasswordFilled && Object.values(validity).every(v => v)) {

      console.log(JSON.stringify({
        data: {
          user_id: userid,
          email:emailId,
          old_password:oldPassword,
          new_password: password,
          confirm_password: passwordAgain
        }
      }));
    
      // Perform the API call to change the password
    const response = await fetch(`${apiEndPoint}/change_password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: encryptData({
        data: {
          user_id: userid,
          email:emailId,
          old_password:oldPassword,
          new_password: password,
          confirm_password: passwordAgain
        }
      })
    });

    const result = await response.json();
     const data = decryptData(result);

     console.log(data);
     console.log(data.data.status);


    // Handle the API response
    if (data.data.status === "error") {
      toastIdRef.current = toast({ description: data.data.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
      return false;
    } else {      
      sessionStorage.clear();
      toastIdRef.current = toast({ description: "Password changed successfully", status: 'success', duration: 5000, isClosable: true, position: 'bottom', });
      
      setTimeout(() => {
        navigate('/');
      }, 3000);

      return true;
    }

    } else {

      toastIdRef.current = toast({ description: "Password does not meet the required criteria", status: 'error', duration: 5000, isClosable: true, position: 'bottom', });

      return false;
    }
  };


  return (
    <>
      <Sidebar/>
      <ChakraProvider resetCSS={false}> <Wrap> </Wrap> </ChakraProvider>

      <div className="loader-container">
        <div className={`loader`}>
          <div className="loader__icon">
            <svg width="80" height="80" viewBox="0 0 67 67" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_1_591)">
                <rect y="0.282349" width="66.4354" height="66.4354" rx="15.0491" fill="#141B3C" />
                <rect x="17.0926" y="34.8087" width="0" height="7.12692" rx="3.56346" transform="rotate(-38.5482 17.0926 34.8087)" fill="#FDCC72">
                  <animate attributeName="width" dur="2s" from="0" to="71.9071" repeatCount="indefinite" />
                </rect>
                <rect x="13.556" y="50.7231" width="0" height="6.18755" rx="3.09378" transform="rotate(-38.5482 13.556 50.7231)" fill="#FDCC72">
                  <animate attributeName="width" dur="2s" from="0" to="71.9071" repeatCount="indefinite" />
                </rect>
                <path id="line1" d="M-2.48236 42.6675L20.5136 23.3716" stroke="white" strokeWidth="5.89403" strokeLinecap="round" strokeDasharray="150" strokeDashoffset="150">
                  <animate attributeName="stroke-dashoffset" dur="2s" repeatCount="indefinite" from="150" to="0" />
                </path>
                <path id="line2" d="M20.6283 23.5651L40.9626 46.5518" stroke="white" strokeWidth="5.89403" strokeLinecap="round" strokeDasharray="150" strokeDashoffset="150">
                  <animate attributeName="stroke-dashoffset" dur="2s" repeatCount="indefinite" from="150" to="0" />
                </path>
                <path id="line3" d="M41.2585 46.6971L77.2121 17.9658" stroke="white" strokeWidth="5.89403" strokeLinecap="round" strokeDasharray="150" strokeDashoffset="150">
                  <animate attributeName="stroke-dashoffset" dur="2s" repeatCount="indefinite" from="150" to="0" />
                </path>
              </g>
              <defs>
                <clipPath id="clip0_1_591">
                  <rect y="0.282349" width="66.4354" height="66.4354" rx="15.0491" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="loader__tile"></div>
        </div>
      </div>
      
      <div className="login_wrapper_ChangePassword ">
        <div className='login_content'>
          <div className='login_header'>
            <div className='login_logo'>
              <img src={Logo} alt="Logo" />
            </div>
            <div className='login_header_text' style={{marginTop:15,}}>
              <h3>Change Password</h3>
            </div>
          </div>
          <div className='login_form'>
            <form>

              <div className='field_row'>
                <label className='custom_label'>Old Password</label>
                <div className='text_field'>
                  <input 
                    type={showPassword1 ? 'text' : 'password'}
                    className='form-control'
                    onChange={handleOldPasswordChange}
                  />
                  <div className='icon_field' onClick={togglePasswordVisibility1}>
                    {showPassword1 ? <PasswordShow /> : <PasswordHide />}
                  </div>
                </div>
              </div>

              <div className='field_row'>
                <label className='custom_label'>New Password</label>
                <div className='text_field'>
                  <input 
                    type={showPassword ? 'text' : 'password'}
                    className='form-control'
                    onChange={handlePasswordChange}
                  />
                  <div className='icon_field' onClick={togglePasswordVisibility}>
                    {showPassword ? <PasswordShow /> : <PasswordHide />}
                  </div>
                </div>
              </div>

              <div className='field_row'>
                <label className='custom_label'>Confirm Password</label>
                <div className='text_field'>
                  <input
                    type={showPassword2 ? 'text' : 'password'}
                    className='form-control'
                    onChange={handlePasswordAgainChange}
                  />
                  <div className='icon_field' onClick={togglePasswordVisibility2}>
                    {showPassword2 ? <PasswordShow /> : <PasswordHide />}
                  </div>
                </div>
              </div>

              <div className='password_error_msg'>
                  {!isPasswordFilled && (
                    <ul className='message_default'>
                      <li>Must be at least 8 characters long</li>
                      <li>Include both uppercase and lowercase letters</li>
                      <li>Use special characters and numbers</li>
                    </ul>
                  )}

                  {isPasswordFilled && (
                    <ul className='message_after_type'>
                      <li className={validity.minLength ? 'valid' : 'invalid'}>Must be at least 8 characters long</li>
                      <li className={validity.capital ? 'valid' : 'invalid'}>Include both uppercase and lowercase letters</li>
                      <li className={validity.specialChar ? 'valid' : 'invalid'}>Use special characters and numbers</li>
                    </ul>
                  )}

                  {/* Example icons based on validity */}
                  {isPasswordFilled && Object.values(validity).every(v => v) && (
                    <IconValid />
                  )}
                  {isPasswordFilled && !Object.values(validity).every(v => v) && (
                    <IconInvalid />
                  )}
                </div>

              <div className='mt-5'>
                <button 
                  type='button' 
                  className={`btn_login ${isPasswordFilled && Object.values(validity).every(v => v) ? 'valid' : ''}`} 
                  onClick={handleChangePassword}
                >
                  Change Password
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChangePassword;
